import { put } from '@redux-saga/core/effects';
import { CANCEL_ONBOARDING, CREATE_COMPOSITE_INPUT_ELEMENT, CREATE_FORM_ACTION_ELEMENT, CREATE_FORM_INPUT_ELEMENT, CREATE_ONBOARDING_SUBMISSION, DELETE_COMPOSITE_INPUT_ELEMENT, DELETE_FORM_INPUT_ELEMENT, DELETE_ONBOARDING, EDIT_COMPOSITE_INPUT_ELEMENT, EDIT_FORM_INPUT_ELEMENT, GET_FORM_INPUT_ELEMENT_BY_ID, GET_ONBOARDING_ALL, GET_ONBOARDING_BY_ID, GET_ONBOARDING_FORM_BY_ID, GET_ONBOARDING_FORMS, START_ONBOARDING_EDIT, STOP_ONBOARDING_EDIT, SUBMIT_ONBOARDING, UPLOAD_ONBOARDING_DOCUMENT } from './onboardingActionTypes';
import { OnboardingService } from '../../../services/onboardingService';

export function* getOnboardingAll(action) {
  try {
    yield put({ type: GET_ONBOARDING_ALL.REQUEST });
    const response = yield OnboardingService.getOnboardingAll(action.payload);
    if (response.status === 200) {
      yield put({ type: GET_ONBOARDING_ALL.SUCCESS, payload: response.data });
    } else {
      yield put({
        type: GET_ONBOARDING_ALL.ERROR,
        payload: response.response.data.message,
      });
    }
  } catch (e) {
    yield put({
      type: GET_ONBOARDING_ALL.ERROR,
      payload: e.response.data.message,
    });
  }
}

export function* getOnboardingById(action) {
  try {
    yield put({ type: GET_ONBOARDING_BY_ID.REQUEST });
    const response = yield OnboardingService.getOnboardingById(action.payload);
    if (response.status === 200) {
      yield put({ type: GET_ONBOARDING_BY_ID.SUCCESS, payload: response.data });
    } else {
      yield put({
        type: GET_ONBOARDING_BY_ID.ERROR,
        payload: response.response.data.message,
      });
    }
  } catch (e) {
    yield put({
      type: GET_ONBOARDING_BY_ID.ERROR,
      payload: e.response.data.message,
    });
  }
}

export function* deleteOnboarding(action) {
  const { id, accountId } = action.payload;
  try {
    yield put({ type: DELETE_ONBOARDING.REQUEST });
    const response = yield OnboardingService.deleteOnboarding(id);
    if (response.status === 200) {
      yield put({ type: DELETE_ONBOARDING.SUCCESS, payload: response.data });
      yield put({ type: GET_ONBOARDING_ALL.ACTION, payload: accountId });
    } else {
      yield put({
        type: DELETE_ONBOARDING.ERROR,
        payload: response.response.data.message,
      });
    }
  } catch (e) {
    yield put({
      type: DELETE_ONBOARDING.ERROR,
      payload: e.response.data.message,
    });
  }
}

export function* getOnboardingForms() {
  try {
    yield put({ type: GET_ONBOARDING_FORMS.REQUEST });
    const response = yield OnboardingService.getOnboardingForms();
    if (response.status === 200) {
      yield put({ type: GET_ONBOARDING_FORMS.SUCCESS, payload: response.data });
    } else {
      yield put({
        type: GET_ONBOARDING_FORMS.ERROR,
        payload: response.response.data.message,
      });
    }
  } catch (e) {
    yield put({
      type: GET_ONBOARDING_FORMS.ERROR,
      payload: e.response.data.message,
    });
  }
}

export function* getOnboardingFormById(action) {
  try {
    yield put({ type: GET_ONBOARDING_FORM_BY_ID.REQUEST });
    const response = yield OnboardingService.getOnboardingFormById(action.payload);
    if (response.status === 200) {
      yield put({ type: GET_ONBOARDING_FORM_BY_ID.SUCCESS, payload: response.data });
    } else {
      yield put({
        type: GET_ONBOARDING_FORM_BY_ID.ERROR,
        payload: response.response.data.message,
      });
    }
  } catch (e) {
    yield put({
      type: GET_ONBOARDING_FORM_BY_ID.ERROR,
      payload: e.response.data.message,
    });
  }
}

export function* createOnboardingSubmission(action) {
  try {
    yield put({ type: CREATE_ONBOARDING_SUBMISSION.REQUEST });
    const response = yield OnboardingService.createOnboardingSubmission(action.payload);
    if (response.status === 200) {
      yield put({ type: CREATE_ONBOARDING_SUBMISSION.SUCCESS, payload: response.data });
      yield put({ type: START_ONBOARDING_EDIT.ACTION, payload: response.data.id });
    } else {
      yield put({
        type: CREATE_ONBOARDING_SUBMISSION.ERROR,
        payload: response.response.data.message,
      });
    }
  } catch (e) {
    yield put({
      type: CREATE_ONBOARDING_SUBMISSION.ERROR,
      payload: e.response.data.message,
    });
  }
}

export function* startOnboardingEdit(action) {
  try {
    yield put({ type: START_ONBOARDING_EDIT.REQUEST });
    const response = yield OnboardingService.startOnboardingEdit(action.payload);
    if (response.status === 200) {
      yield put({ type: START_ONBOARDING_EDIT.SUCCESS, payload: response.data });
      yield put({ type: GET_ONBOARDING_BY_ID.ACTION, payload: action.payload });
    } else {
      yield put({
        type: START_ONBOARDING_EDIT.ERROR,
        payload: response.response.data.message,
      });
    }
  } catch (e) {
    yield put({
      type: START_ONBOARDING_EDIT.ERROR,
      payload: e.response.data.message,
    });
  }
}

export function* stopOnboardingEdit(action) {
  try {
    yield put({ type: STOP_ONBOARDING_EDIT.REQUEST });
    const response = yield OnboardingService.stopOnboardingEdit(action.payload);
    if (response.status === 200) {
      yield put({ type: STOP_ONBOARDING_EDIT.SUCCESS, payload: response.data });
    } else {
      yield put({
        type: STOP_ONBOARDING_EDIT.ERROR,
        payload: response.response.data.message,
      });
    }
  } catch (e) {
    yield put({
      type: STOP_ONBOARDING_EDIT.ERROR,
      payload: e.response.data.message,
    });
  }
}

export function* uploadOnboardingDocument(action) {
  try {
    yield put({ type: UPLOAD_ONBOARDING_DOCUMENT.REQUEST });
    const response = yield OnboardingService.uploadOnboardingDocument(action.payload);
    if (response.status === 200) {
      yield put({ type: UPLOAD_ONBOARDING_DOCUMENT.SUCCESS });
      yield put({ type: GET_ONBOARDING_BY_ID.ACTION, payload: action.payload.form_submission_id });
    } else {
      yield put({
        type: UPLOAD_ONBOARDING_DOCUMENT.ERROR,
        payload: response.response.data.message,
      });
    }
  } catch (e) {
    yield put({
      type: CREATE_FORM_INPUT_ELEMENT.ERROR,
      payload: e.response.data.message,
    });
  }
}

export function* getFormInputElementById(action) {
  try {
    yield put({ type: GET_FORM_INPUT_ELEMENT_BY_ID.REQUEST });
    const response = yield OnboardingService.getFormInputElementById(action.payload);
    if (response.status === 200) {
      yield put({ type: GET_FORM_INPUT_ELEMENT_BY_ID.SUCCESS, payload: response.data });
    } else {
      yield put({
        type: GET_FORM_INPUT_ELEMENT_BY_ID.ERROR,
        payload: response.response.data.message,
      });
    }
  } catch (e) {
    yield put({
      type: GET_FORM_INPUT_ELEMENT_BY_ID.ERROR,
      payload: e.response.data.message,
    });
  }
}

export function* createFormInputElement(action) {
  try {
    yield put({ type: CREATE_FORM_INPUT_ELEMENT.REQUEST });
    const response = yield OnboardingService.createFormInputElement(action.payload);
    if (response.status === 200) {
      yield put({ type: CREATE_FORM_INPUT_ELEMENT.SUCCESS, payload: response.data });
      yield put({ type: GET_ONBOARDING_BY_ID.ACTION, payload: action.payload.form_submission_id });
    } else {
      yield put({
        type: CREATE_FORM_INPUT_ELEMENT.ERROR,
        payload: response.response.data.message,
      });
    }
  } catch (e) {
    yield put({
      type: CREATE_FORM_INPUT_ELEMENT.ERROR,
      payload: e.response.data.message,
    });
  }
}

export function* editFormInputElement(action) {
  try {
    yield put({ type: EDIT_FORM_INPUT_ELEMENT.REQUEST });
    const response = yield OnboardingService.editFormInputElement(action.payload);
    if (response.status === 200) {
      yield put({ type: EDIT_FORM_INPUT_ELEMENT.SUCCESS, payload: response.data });
    } else {
      yield put({
        type: EDIT_FORM_INPUT_ELEMENT.ERROR,
        payload: response.response.data.message,
      });
    }
  } catch (e) {
    yield put({
      type: EDIT_FORM_INPUT_ELEMENT.ERROR,
      payload: e.response.data.message,
    });
  }
}

export function* deleteFormInputElement(action) {
  try {
    yield put({ type: DELETE_FORM_INPUT_ELEMENT.REQUEST });
    const response = yield OnboardingService.deleteFormInputElement(action.payload);
    if (response.status === 200) {
      yield put({ type: DELETE_FORM_INPUT_ELEMENT.SUCCESS, payload: response.data });
    } else {
      yield put({
        type: DELETE_FORM_INPUT_ELEMENT.ERROR,
        payload: response.response.data.message,
      });
    }
  } catch (e) {
    yield put({
      type: DELETE_FORM_INPUT_ELEMENT.ERROR,
      payload: e.response.data.message,
    });
  }
}

export function* createCompositeInputElement(action) {
  try {
    yield put({ type: CREATE_COMPOSITE_INPUT_ELEMENT.REQUEST });
    const response = yield OnboardingService.createCompositeInputElement(action.payload);
    if (response.status === 200) {
      yield put({ type: CREATE_COMPOSITE_INPUT_ELEMENT.SUCCESS, payload: response.data });
      yield put({ type: GET_ONBOARDING_BY_ID.ACTION, payload: action.payload.form_submission_id });
    } else {
      yield put({
        type: CREATE_COMPOSITE_INPUT_ELEMENT.ERROR,
        payload: response.response.data.message,
      });
    }
  } catch (e) {
    yield put({
      type: CREATE_COMPOSITE_INPUT_ELEMENT.ERROR,
      payload: e.response.data.message,
    });
  }
}

export function* editCompositeInputElement(action) {
  try {
    yield put({ type: EDIT_COMPOSITE_INPUT_ELEMENT.REQUEST });
    const response = yield OnboardingService.editCompositeInputElement(action.payload);
    if (response.status === 200) {
      yield put({ type: EDIT_COMPOSITE_INPUT_ELEMENT.SUCCESS, payload: response.data });
      yield put({ type: GET_ONBOARDING_BY_ID.ACTION, payload: action.payload.form_submission_id });
    } else {
      yield put({
        type: EDIT_COMPOSITE_INPUT_ELEMENT.ERROR,
        payload: response.response.data.message,
      });
    }
  } catch (e) {
    yield put({
      type: EDIT_COMPOSITE_INPUT_ELEMENT.ERROR,
      payload: e.response.data.message,
    });
  }
}

export function* deleteCompositeInputElement(action) {
  try {
    yield put({ type: DELETE_COMPOSITE_INPUT_ELEMENT.REQUEST });
    const response = yield OnboardingService.deleteCompositeInputElement(action.payload);
    if (response.status === 200) {
      yield put({ type: DELETE_COMPOSITE_INPUT_ELEMENT.SUCCESS, payload: response.data });
    } else {
      yield put({
        type: DELETE_COMPOSITE_INPUT_ELEMENT.ERROR,
        payload: response.response.data.message,
      });
    }
  } catch (e) {
    yield put({
      type: DELETE_COMPOSITE_INPUT_ELEMENT.ERROR,
      payload: e.response.data.message,
    });
  }
}

export function* createFormActionElement(action) {
  try {
    yield put({ type: CREATE_FORM_ACTION_ELEMENT.REQUEST });
    const response = yield OnboardingService.createFormActionElement(action.payload);
    if (response.status === 200) {
      yield put({ type: CREATE_FORM_ACTION_ELEMENT.SUCCESS, payload: response.data });
    } else {
      yield put({
        type: CREATE_FORM_ACTION_ELEMENT.ERROR,
        payload: response.response.data.message,
      });
    }
  } catch (e) {
    yield put({
      type: CREATE_FORM_ACTION_ELEMENT.ERROR,
      payload: e.response.data.message,
    });
  }
}

export function* submitOnboarding(action) {
  try {
    yield put({ type: SUBMIT_ONBOARDING.REQUEST });
    const response = yield OnboardingService.submitOnboarding(action.payload);
    if (response.status === 200) {
      yield put({ type: SUBMIT_ONBOARDING.SUCCESS, payload: response.data });
    } else {
      yield put({
        type: SUBMIT_ONBOARDING.ERROR,
        payload: response.response.data.message,
      });
    }
  } catch (e) {
    yield put({
      type: SUBMIT_ONBOARDING.ERROR,
      payload: e.response.data.message,
    });
  }
}

export function* cancelOnboarding(action) {
  const { id, accountId } = action.payload;
  try {
    yield put({ type: CANCEL_ONBOARDING.REQUEST });
    const response = yield OnboardingService.cancelOnboarding(id);
    if (response.status === 200) {
      yield put({ type: CANCEL_ONBOARDING.SUCCESS, payload: response.data });
      yield put({ type: GET_ONBOARDING_ALL.ACTION, payload: accountId });
    } else {
      yield put({
        type: CANCEL_ONBOARDING.ERROR,
        payload: response.response.data.message,
      });
    }
  } catch (e) {
    yield put({
      type: CANCEL_ONBOARDING.ERROR,
      payload: e.response.data.message,
    });
  }
}